var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbItems}}),_vm._v(" "),_c('div',{staticClass:"grid grid-cols-12 base-responsive-gap mt-6"},[_c('div',{staticClass:"col-span-12 lg:col-span-7"},[_c('h1',{staticClass:"header-1 mb-4"},[_c('T',{attrs:{"t":"complaint_report.title"}})],1),_vm._v(" "),_c('ComplaintReportHubspotForm')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }